import React from "react";

export interface OriginsListItemConverterProps {
    children?: React.ReactNodeArray;
    className?: string;
    datalabel?: string;
}

const OriginsListItemConverter = (props: OriginsListItemConverterProps) => {
    // There are times where props.children is undefined
    if (props.children == null) {
        return null;
    }

    return <li className="c-origins-list__item">{props.children}</li>;
};

export default OriginsListItemConverter;
